import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=aaa9afd6&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=aaa9afd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa9afd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aaa9afd6')) {
      api.createRecord('aaa9afd6', component.options)
    } else {
      api.reload('aaa9afd6', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=aaa9afd6&scoped=true&", function () {
      api.rerender('aaa9afd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-41eEIz398RefR/JS/comp/CookieBox.vue"
export default component.exports